module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/modal/modal.component.scss
// module id = ./src/app/shared/components/modal/modal.component.scss
// module chunks = main